<template>
  <div :key="componentKey" :class="{
    'cui__layout__grayBackground': settings.isGrayBackground,
  }">
    <a-layout
      :class="{
      'cui__layout__contentMaxWidth': settings.isContentMaxWidth,
      'cui__layout__appMaxWidth': settings.isAppMaxWidth,
      'cui__layout__grayBackground': settings.isGrayBackground,
      'cui__layout__squaredBorders': settings.isSquaredBorders,
      'cui__layout__cardsShadow': settings.isCardShadow,
      'cui__layout__borderless': settings.isBorderless,
    }"
    >
      <b-modal>
        <div>You need to update your subscription.</div>
      </b-modal>
      <!-- <cui-sidebar /> -->
      <!-- <cui-sidebar />
      <cui-support-chat /> -->

      <!-- left menu -->
      <cui-menu-left v-if="settings.menuLayoutType === 'left' && !settings.isMobileView" />

      <!-- left menu mobile -->
      <div v-if="settings.isMobileView">
        <div :class="$style.handler" @click="toggleMobileMenu">
          <div :class="$style.handlerIcon"></div>
        </div>
        <a-drawer
          :closable="false"
          :visible="settings.isMobileMenuOpen"
          placement="left"
          :wrapClassName="$style.mobileMenu"
          @close="toggleMobileMenu"
        >
          <cui-menu-left />
        </a-drawer>
      </div>

      <!-- top menu -->
      <cui-menu-top v-if="settings.menuLayoutType === 'top' && !settings.isMobileView" />

      <a-layout>
        <a-layout-header
          :class="{
          'cui__layout__header': true,
          'cui__layout__fixedHeader': settings.isTopbarFixed,
          'cui__layout__headerGray': settings.isGrayTopbar,
        }"
        >
          <cui-topbar />
        </a-layout-header>
        <cui-breadcrumbs />
        <a-layout-content style="height: '100%';  position: 'relative'">
          <div class="cui__utils__content">
            <transition :name="settings.routerAnimation" mode="out-in">
              <router-view />
            </transition>
          </div>
        </a-layout-content>
        <a-layout-footer>
          <cui-footer />
        </a-layout-footer>
      </a-layout>
    </a-layout>
    <!-- </b-overlay> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import CuiTopbar from '@/components/cleanui/layout/Topbar'
import CuiBreadcrumbs from '@/components/cleanui/layout/Breadcrumbs'
import CuiFooter from '@/components/cleanui/layout/Footer'
// import CuiSidebar from '@/components/cleanui/layout/Sidebar'
// import CuiSupportChat from '@/components/cleanui/layout/SupportChat'
import CuiMenuLeft from '@/components/cleanui/layout/Menu/MenuLeft'
import CuiMenuTop from '@/components/cleanui/layout/Menu/MenuTop'
// import Onboarding from '@/components/plannervid/Onboard'

import { firebaseAuth, firebaseDatabase } from '@/services/firebase'

const pendo = window.pendo

export default {
  name: 'MainLayout',
  components: { CuiFooter, CuiTopbar, CuiMenuLeft, CuiMenuTop, CuiBreadcrumbs },
  computed: mapState(['settings']),
  data() {
    return {
      touchStartPrev: 0,
      touchStartLocked: false,
      onboarded: true,
      overlay: false,
      componentKey: 0,
    }
  },
  mounted() {
    this.bindMobileSlide()
    this.detectViewPort(true)
    window.addEventListener('resize', this.detectViewPortListener)
    pendo.initialize({
      visitor: {
        id: firebaseAuth.currentUser.uid,
      },
      account: {
        id: 'plannervid',
      },
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.detectViewPortListener)
  },
  created() {
    // this.checkOnboard()
    this.checkChannelConnection()
    window.addEventListener('beforeunload', this.warning)
  },
  methods: {
    warning() {
      if (this.$store.state.creator.changes) {
        console.log(this.$store.state.creator.changes)
        window.event.returnValue = 'not good, but kinda I guess'
      } else console.log(this.$store.state.creator.changes)
    },
    checkChannelConnection() {
      console.log('main >> checkChannelConnection')
      console.log(firebaseAuth.currentUser.uid)
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .get()
        .then((doc) => {
          const channel = doc.data().channel
          if (channel) {
            this.getChannelData()
            // this.getYoutubeData()
          }
        })
      this.$store.dispatch('creator/strategy/getPillars')
      this.$store.dispatch('creator/videos/getVideos')
      this.$store.dispatch('creator/ideas/getBoards')
      this.$store.dispatch('creator/collabs/getCollabs')
    },
    async getChannelData() {
      // need to refresh on OAuth response
      // how to save permission and not redo on every login?
      this.$store.state.user.channelLoading = true
      this.getOAuthData()
      // this.getOAuthData2()
      this.getAnalyticsData()
      this.getAnalyticsDataSnippet()
      this.getAnalyticsDataStatistics()
      this.getAnalyticsDataBranding()
    },
    checkOnboard() {
      console.log('main >> checkOnboard')
      firebaseDatabase.collection('creators').doc(firebaseAuth.currentUser.uid).get()
        .then((doc) => {
          const data = doc.data().onboarded
          this.onboarded = data
          this.overlay = !data
          if (data) {
            console.log('main >> checkOnboard >> ' + data)
            // this.$refs.onboarding.show()
          } else {
            console.log('main >> checkOnboard >> else')
            this.getOAuthData()
            this.getOAuthData2()
            this.getAnalyticsData()
            this.getAnalyticsDataSnippet()
            this.getAnalyticsDataStatistics()
            this.getAnalyticsDataBranding()
            this.getPillars()
            this.getVideos()
            this.getBoards()
            this.getCollabs()
          }
        })
    },
    authGetData() {
      console.log('authRefresh emit received')
      this.getAnalyticsData()
      this.getAnalyticsDataSnippet()
      this.getAnalyticsDataStatistics()
      this.getAnalyticsDataBranding()
      this.getOAuthData()
      this.getOAuthData2()
      this.getAnalyticsData()
      this.getAnalyticsDataSnippet()
      this.getAnalyticsDataStatistics()
      this.getAnalyticsDataBranding()
      this.getPillars()
      this.getVideos()
      this.getBoards()
      this.getCollabs()
    },
    exitModal() {
      console.log('emit received')
      // this.$refs.onboarding.hide()
      this.authGetData()
      this.overlay = false
      this.componentKey += 1
    },
    getYoutubeData() {
      const promiseA = new Promise(this.getOAuthData)
      promiseA.then(console.log('this.getYoutubeApiData'))
    },
    getOAuthData() {
      console.log('main >> getOAuthData')
      this.$gapi.getGapiClient().then((gapi) => {
        gapi.client.load('https://youtubeanalytics.googleapis.com/$discovery/rest?version=v2')
        const googleAuth = gapi.auth2.getAuthInstance()
        googleAuth.isSignedIn.listen(function() {
          this.getYoutubeApiData()
        })
        if (!googleAuth.isSignedIn.get()) {
          googleAuth.signIn()
        }
      })
      this.$gapi.getGapiClient().then((gapi) => {
        gapi.client.load('https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest')
        const googleAuth = gapi.auth2.getAuthInstance()
        googleAuth.isSignedIn.listen(function() {
        })
        if (!googleAuth.isSignedIn.get()) {
          googleAuth.signIn()
        }
      })
    },
    getOAuthData2() {
      console.log('main >> getOAuthData2')
      this.$gapi.getGapiClient().then((gapi) => {
        gapi.client.load('https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest')
        const googleAuth = gapi.auth2.getAuthInstance()
        googleAuth.isSignedIn.listen(function() {
        })
        if (!googleAuth.isSignedIn.get()) {
          googleAuth.signIn()
        }
      })
    },
    getYoutubeApiData() {
      this.getAnalyticsData()
      this.getAnalyticsDataSnippet()
      this.getAnalyticsDataStatistics()
      this.getAnalyticsDataBranding()
      // this.$store.state.user.channelLoading = false
    },
    getAnalyticsData() {
      console.log('main >> getAnalyticsData')
      const today = moment().format('YYYY-MM-DD')
      const rangeStart = moment().subtract(30, 'days').format('YYYY-MM-DD')
      this.$gapi.getGapiClient().then((gapi) => {
        var request = gapi.client.request({
          method: 'GET',
          path: 'https://youtubeanalytics.googleapis.com/v2/reports/',
          params: { ids: 'channel==MINE', startDate: rangeStart, endDate: today, metrics: 'views,subscribersGained,subscribersLost,averageViewDuration,estimatedMinutesWatched' },
        })
        request.execute((response) => {
          this.$store.dispatch('youtube/getYoutubeData', response)
        })
      })
      // this.$store.state.user.channelLoading = false
    },
    getAnalyticsDataSnippet() {
      console.log('main >> getAnalyticsDataSnippet')
      this.$gapi.getGapiClient().then((gapi) => {
        var request = gapi.client.request({
          method: 'GET',
          path: 'https://content-youtube.googleapis.com/youtube/v3/channels',
          params: { part: 'snippet', mine: 'true', key: 'AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc' },
        })
        request.execute((response) => {
          this.$store.state.user.channelLoading = false
          this.$store.state.user.attemptedConnection = true
          this.$store.dispatch('youtube/getChannelSnippet', response)
        })
      })
    },
    getAnalyticsDataStatistics() {
      console.log('main >> getAnalyticsDataStatistics')
      this.$gapi.getGapiClient().then((gapi) => {
        var request = gapi.client.request({
          method: 'GET',
          path: 'https://content-youtube.googleapis.com/youtube/v3/channels',
          params: { part: 'statistics', mine: 'true', key: 'AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc' },
        })
        request.execute((response) => {
          this.$store.dispatch('youtube/getChannelStatistics', response)
        })
      })
    },
    getAnalyticsDataBranding() {
      console.log('main >> getAnalyticsDataBranding')
      this.$gapi.getGapiClient().then((gapi) => {
        var request = gapi.client.request({
          method: 'GET',
          path: 'https://content-youtube.googleapis.com/youtube/v3/channels',
          params: { part: 'brandingSettings', mine: 'true', key: 'AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc' },
        })
        request.execute((response) => {
          this.$store.dispatch('youtube/getChannelBranding', response)
        })
      })
    },
    async getPillars() {
      try {
        // await this.$store.dispatch('strategy/pillars/getPillars')
        await this.$store.dispatch('creator/strategy/getPillars')
      } catch (error) {
        this.error = error.message || 'Something went wrong!'
      }
    },
    async getVideos() {
      try {
        // await this.$store.dispatch('videos/getVideos')
        await this.$store.dispatch('creator/videos/getVideos')
      } catch (error) {
        this.error = error.message || 'Something went wrong!'
      }
    },
    async getBoards() {
      try {
        // await this.$store.dispatch('ideas/getBoards')
        await this.$store.dispatch('creator/ideas/getBoards')
      } catch (error) {
        this.error = error.message || 'Something went wrong!'
      }
    },
    async getCollabs() {
      try {
        // await this.$store.dispatch('collabs/getCollabs')
        await this.$store.dispatch('creator/collabs/getCollabs')
      } catch (error) {
        this.error = error.message || 'Something went wrong!'
      }
    },
    toggleMobileMenu() {
      const value = !this.settings.isMobileMenuOpen
      this.$store.commit('CHANGE_SETTING', { setting: 'isMobileMenuOpen', value })
    },
    changeSetting: function (setting, value) {
      this.$store.commit('CHANGE_SETTING', { setting, value })
    },
    setViewPort: function (isMobileView = false, isTabletView = false) {
      this.$store.commit('CHANGE_SETTING', { setting: 'isMobileView', value: isMobileView })
      this.$store.commit('CHANGE_SETTING', { setting: 'isTabletView', value: isTabletView })
    },
    detectViewPortListener: function () {
      this.detectViewPort(false)
    },
    detectViewPort: function (firstLoad = false) {
      const isMobile = this.settings.isMobileView
      const isTablet = this.settings.isTabletView
      const width = window.innerWidth
      const state = {
        next: {
          mobile: width < 768,
          tablet: width < 992,
          desktop: !(width < 768) && !(width < 992),
        },
        prev: {
          mobile: isMobile,
          tablet: isTablet,
          desktop: !(isMobile) && !(isTablet),
        },
      }
      // desktop
      if (state.next.desktop && ((state.next.desktop !== state.prev.desktop) || firstLoad)) {
        this.setViewPort(false, false)
      }
      // tablet & collapse menu
      if (state.next.tablet && !state.next.mobile && ((state.next.tablet !== state.prev.tablet) || firstLoad)) {
        this.setViewPort(false, true)
        this.$store.commit('CHANGE_SETTING', { setting: 'isMenuCollapsed', value: true })
      }
      // mobile
      if (state.next.mobile && ((state.next.mobile !== state.prev.mobile) || firstLoad)) {
        this.setViewPort(true, false)
      }
    },
    bindMobileSlide() {
      // mobile menu touch slide opener
      const unify = e => {
        return e.changedTouches ? e.changedTouches[0] : e
      }
      document.addEventListener(
        'touchstart',
        e => {
          const x = unify(e).clientX
          this.touchStartPrev = x
          this.touchStartLocked = x > 70
        },
        { passive: false },
      )
      document.addEventListener(
        'touchmove',
        e => {
          const x = unify(e).clientX
          const prev = this.touchStartPrev
          if (x - prev > 50 && !this.touchStartLocked) {
            this.toggleMobileMenu()
            this.touchStartLocked = true
          }
        },
        { passive: false },
      )
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
